"use client";

import type { FeatureCollection } from "geojson";
import { useAtomValue } from "jotai";
import type { LngLatLike, Map } from "maplibre-gl";
import { RMap, RNavigationControl } from "maplibre-react-components";
import React, { useRef, type ReactElement } from "react";
import { WeatherStationLayer, WeatherStationPopup } from "@/components";
import { mapTileAtom } from "@/store/sites";
import { activeStationAtom } from "@/store/weather";

interface WeatherMapProps {
  features: FeatureCollection;
}

function WeatherMap({ features }: Readonly<WeatherMapProps>): ReactElement {
  const activeStation = useAtomValue(activeStationAtom);
  const mapRef = useRef<Map>(null);
  const center: LngLatLike = [2.5911028, 46.1106885];
  const tile = useAtomValue(mapTileAtom);

  return (
    <RMap
      id="map"
      initialCanvasContextAttributes={{ antialias: true }}
      initialCenter={center}
      initialZoom={5}
      mapStyle={tile.url}
      ref={mapRef}
    >
      <RNavigationControl position="top-right" visualizePitch />
      {activeStation ? <WeatherStationPopup station={activeStation} /> : null}
      <WeatherStationLayer features={features} />
    </RMap>
  );
}

export { WeatherMap, type WeatherMapProps };
